import React from 'react';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import TooltipButton from './tooltip-button/tooltip-button';
import UserUtils, { RightDef } from '../utils/userUtils';

/**
 * A component to render a global loading spinner before displaying some data on a page
 */

interface ButtonToProps extends WithTranslation {
    to: string;
    text: string;
    startIcon?: JSX.Element;
    style?: React.CSSProperties;
    className?: string;
    rights?: string | RightDef | RightDef[];
    buttonProps?: any;
    variante?: 'round' | 'rectangle';
}

const ButtonTo = (props: ButtonToProps): JSX.Element => {
    const classes = useTabStyles({});
    const { t, startIcon, to, text, style, className, rights, variante = 'round' } = props;
    let { buttonProps } = props;
    const hasRight = UserUtils.checkRights(rights);
    if (hasRight) {
        buttonProps = buttonProps ?? {};
        buttonProps.to = to;
        buttonProps.component = RouterLink;
    }

    return (
        <TooltipButton title={!hasRight ? t('common:rights.noAction') : text}>
            <div>
                <Button
                    aria-label={text}
                    variant="contained"
                    color="secondary"
                    startIcon={startIcon}
                    className={className ?? classes[`${variante}Button`]}
                    style={{ ...style, ...(hasRight ? {} : { pointerEvents: 'auto' }) }}
                    size="large"
                    disabled={!hasRight}
                    {...buttonProps}
                >
                    {text}
                </Button>
            </div>
        </TooltipButton>
    );
};

const useTabStyles = makeStyles((theme: Theme) =>
    createStyles({
        roundButton: {
            alignSelf: 'flex-end',
            padding: '12px 20px',
            borderRadius: 23,
            textTransform: 'none',
        },
        rectangleButton: {
            alignSelf: 'flex-end',
            padding: '6px 16px',
            textTransform: 'none',
        },
    }),
);

export default withTranslation('common')(ButtonTo);
